import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f955458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container" }
const _hoisted_3 = { class: "header__logo" }
const _hoisted_4 = { href: "/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  id: "header-navigation",
  class: "header__navigation",
  "aria-label": "secondary"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "header__navigation-icon",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 20C8.6 20 7.29167 19.7375 6.075 19.2125C4.85833 18.6875 3.8 17.975 2.9 17.075C2 16.175 1.29167 15.1125 0.775 13.8875C0.258333 12.6625 0 11.35 0 9.95C0 8.55 0.258333 7.24583 0.775 6.0375C1.29167 4.82917 2 3.775 2.9 2.875C3.8 1.975 4.85833 1.27083 6.075 0.7625C7.29167 0.254167 8.6 0 10 0C11.4 0 12.7083 0.254167 13.925 0.7625C15.1417 1.27083 16.2 1.975 17.1 2.875C18 3.775 18.7083 4.82917 19.225 6.0375C19.7417 7.24583 20 8.55 20 9.95C20 11.35 19.7417 12.6625 19.225 13.8875C18.7083 15.1125 18 16.175 17.1 17.075C16.2 17.975 15.1417 18.6875 13.925 19.2125C12.7083 19.7375 11.4 20 10 20ZM10 18.55C10.5833 17.95 11.0708 17.2625 11.4625 16.4875C11.8542 15.7125 12.175 14.7917 12.425 13.725H7.6C7.83333 14.725 8.14583 15.625 8.5375 16.425C8.92917 17.225 9.41667 17.9333 10 18.55ZM7.875 18.25C7.45833 17.6167 7.1 16.9333 6.8 16.2C6.5 15.4667 6.25 14.6417 6.05 13.725H2.3C2.93333 14.9083 3.66667 15.8375 4.5 16.5125C5.33333 17.1875 6.45833 17.7667 7.875 18.25ZM12.15 18.225C13.35 17.8417 14.4292 17.2667 15.3875 16.5C16.3458 15.7333 17.1167 14.8083 17.7 13.725H13.975C13.7583 14.625 13.5042 15.4417 13.2125 16.175C12.9208 16.9083 12.5667 17.5917 12.15 18.225ZM1.8 12.225H5.775C5.725 11.775 5.69583 11.3708 5.6875 11.0125C5.67917 10.6542 5.675 10.3 5.675 9.95C5.675 9.53333 5.68333 9.1625 5.7 8.8375C5.71667 8.5125 5.75 8.15 5.8 7.75H1.8C1.68333 8.15 1.60417 8.50833 1.5625 8.825C1.52083 9.14167 1.5 9.51667 1.5 9.95C1.5 10.3833 1.52083 10.7708 1.5625 11.1125C1.60417 11.4542 1.68333 11.825 1.8 12.225ZM7.325 12.225H12.7C12.7667 11.7083 12.8083 11.2875 12.825 10.9625C12.8417 10.6375 12.85 10.3 12.85 9.95C12.85 9.61667 12.8417 9.29583 12.825 8.9875C12.8083 8.67917 12.7667 8.26667 12.7 7.75H7.325C7.25833 8.26667 7.21667 8.67917 7.2 8.9875C7.18333 9.29583 7.175 9.61667 7.175 9.95C7.175 10.3 7.18333 10.6375 7.2 10.9625C7.21667 11.2875 7.25833 11.7083 7.325 12.225ZM14.2 12.225H18.2C18.3167 11.825 18.3958 11.4542 18.4375 11.1125C18.4792 10.7708 18.5 10.3833 18.5 9.95C18.5 9.51667 18.4792 9.14167 18.4375 8.825C18.3958 8.50833 18.3167 8.15 18.2 7.75H14.225C14.275 8.33333 14.3083 8.77917 14.325 9.0875C14.3417 9.39583 14.35 9.68333 14.35 9.95C14.35 10.3167 14.3375 10.6625 14.3125 10.9875C14.2875 11.3125 14.25 11.725 14.2 12.225ZM13.95 6.25H17.7C17.15 5.1 16.3958 4.14167 15.4375 3.375C14.4792 2.60833 13.375 2.06667 12.125 1.75C12.5417 2.36667 12.8958 3.03333 13.1875 3.75C13.4792 4.46667 13.7333 5.3 13.95 6.25ZM7.6 6.25H12.45C12.2667 5.36667 11.9583 4.5125 11.525 3.6875C11.0917 2.8625 10.5833 2.13333 10 1.5C9.46667 1.95 9.01667 2.54167 8.65 3.275C8.28333 4.00833 7.93333 5 7.6 6.25ZM2.3 6.25H6.075C6.25833 5.35 6.49167 4.54583 6.775 3.8375C7.05833 3.12917 7.41667 2.44167 7.85 1.775C6.6 2.09167 5.50833 2.625 4.575 3.375C3.64167 4.125 2.88333 5.08333 2.3 6.25Z",
  fill: "#006656"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__navigation-close-icon",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.15385 15L0 13.8462L6.34615 7.5L0 1.15385L1.15385 0L7.5 6.34615L13.8462 0L15 1.15385L8.65385 7.5L15 13.8462L13.8462 15L7.5 8.65385L1.15385 15Z",
    fill: "#006656"
  })
], -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "header__navigation-icon",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10.25 20V18.3333H18.3333V1.66667H10.25V0H18.3333C18.7778 0 19.1667 0.166667 19.5 0.5C19.8333 0.833333 20 1.22222 20 1.66667V18.3333C20 18.7778 19.8333 19.1667 19.5 19.5C19.1667 19.8333 18.7778 20 18.3333 20H10.25ZM8.08333 14.8611L6.88889 13.6667L9.72222 10.8333H0V9.16667H9.66667L6.83333 6.33333L8.02778 5.13889L12.9167 10.0278L8.08333 14.8611Z",
  fill: "#006656"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__navigation-close-icon",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.15385 15L0 13.8462L6.34615 7.5L0 1.15385L1.15385 0L7.5 6.34615L13.8462 0L15 1.15385L8.65385 7.5L15 13.8462L13.8462 15L7.5 8.65385L1.15385 15Z",
    fill: "#006656"
  })
], -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  class: "header__navigation-icon",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18.7778 20L11.4722 12.6944C10.9167 13.1759 10.2685 13.5509 9.52778 13.8194C8.78704 14.088 8 14.2222 7.16667 14.2222C5.16667 14.2222 3.47222 13.5278 2.08333 12.1389C0.694444 10.75 0 9.07407 0 7.11111C0 5.14815 0.694444 3.47222 2.08333 2.08333C3.47222 0.694444 5.15741 0 7.13889 0C9.10185 0 10.7731 0.694444 12.1528 2.08333C13.5324 3.47222 14.2222 5.14815 14.2222 7.11111C14.2222 7.90741 14.0926 8.67593 13.8333 9.41667C13.5741 10.1574 13.1852 10.8519 12.6667 11.5L20 18.7778L18.7778 20ZM7.13889 12.5556C8.63889 12.5556 9.91667 12.0231 10.9722 10.9583C12.0278 9.89352 12.5556 8.61111 12.5556 7.11111C12.5556 5.61111 12.0278 4.3287 10.9722 3.26389C9.91667 2.19907 8.63889 1.66667 7.13889 1.66667C5.62037 1.66667 4.3287 2.19907 3.26389 3.26389C2.19907 4.3287 1.66667 5.61111 1.66667 7.11111C1.66667 8.61111 2.19907 9.89352 3.26389 10.9583C4.3287 12.0231 5.62037 12.5556 7.13889 12.5556Z",
  fill: "#006656"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__navigation-close-icon",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.15385 15L0 13.8462L6.34615 7.5L0 1.15385L1.15385 0L7.5 6.34615L13.8462 0L15 1.15385L8.65385 7.5L15 13.8462L13.8462 15L7.5 8.65385L1.15385 15Z",
    fill: "#006656"
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__navigation-icon",
  width: "21",
  height: "15",
  viewBox: "0 0 21 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.5 14.1668V12.5002H20.5V14.1668H0.5ZM0.5 8.3335V6.66683H20.5V8.3335H0.5ZM0.5 2.50016V0.833496H20.5V2.50016H0.5Z",
    fill: "white"
  })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__navigation-close-icon",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.15385 15L0 13.8462L6.34615 7.5L0 1.15385L1.15385 0L7.5 6.34615L13.8462 0L15 1.15385L8.65385 7.5L15 13.8462L13.8462 15L7.5 8.65385L1.15385 15Z",
    fill: "#006656"
  })
], -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "header__dropdown-content" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "header__dropdown-content-wrap" }
const _hoisted_28 = { class: "header__dropdown-title" }
const _hoisted_29 = { class: "header__country-list" }
const _hoisted_30 = { class: "header__country-name" }
const _hoisted_31 = ["href"]
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "header__dropdown-content" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__dropdown-content-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__dropdown-title" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Login"),
    /*#__PURE__*/_createTextVNode(" here")
  ])
], -1))
const _hoisted_36 = { class: "header__dropdown-content" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "header__dropdown-content-wrap" }
const _hoisted_39 = { class: "header__dropdown-title" }
const _hoisted_40 = ["action"]
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "a-btn header__search-form-button" }
const _hoisted_43 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", { src: _ctx.companyLogo }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", {
        class: "header__middle-area",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedIndex = -1))
      }),
      _createElementVNode("nav", _hoisted_6, [
        (_ctx.countryLabel != '')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(
            _ctx.selectedIndex === 0
              ? 'header__navigation-item open'
              : 'header__navigation-item'
          ),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNav(0, $event)))
            }, [
              _withDirectives(_createElementVNode("img", {
                class: "header__navigation-icon",
                src: _ctx.countryLogo
              }, null, 8, _hoisted_7), [
                [_vShow, _ctx.selectedIndex != 0]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10, 512)), [
                [_vShow, _ctx.selectedIndex === 0]
              ]),
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.countryLabel), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.loginLabel != '')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(
            _ctx.selectedIndex === 1
              ? 'header__navigation-item open'
              : 'header__navigation-item'
          ),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleNav(1, $event)))
            }, [
              _withDirectives(_createElementVNode("img", {
                class: "header__navigation-icon",
                src: _ctx.loginLogo
              }, null, 8, _hoisted_12), [
                [_vShow, _ctx.selectedIndex != 1]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15, 512)), [
                [_vShow, _ctx.selectedIndex === 1]
              ]),
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.loginLabel), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.searchLabel != '')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(
            _ctx.selectedIndex === 2
              ? 'header__navigation-item open'
              : 'header__navigation-item'
          ),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleNav(2, $event)))
            }, [
              _withDirectives(_createElementVNode("img", {
                class: "header__navigation-icon",
                src: _ctx.searchLogo
              }, null, 8, _hoisted_17), [
                [_vShow, _ctx.selectedIndex != 2]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20, 512)), [
                [_vShow, _ctx.selectedIndex === 2]
              ]),
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.searchLabel), 1)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "menu-toggle",
          class: _normalizeClass(
            _ctx.selectedIndex === 3
              ? 'header__navigation-item header__navigation-item--menu-toggle open'
              : 'header__navigation-item header__navigation-item--menu-toggle'
          ),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleNav(3, $event)))
        }, _hoisted_24, 2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["header__dropdown", _ctx.selectedIndex === 0 ? 'active' : '']),
      tabindex: "0",
      onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.selectedIndex = -1), ["esc"]))
    }, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", {
          class: "header__dropdown-close",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedIndex = -1))
        }, [
          _createTextVNode(_toDisplayString(_ctx.countryCloseLabel) + " ", 1),
          _createElementVNode("img", { src: _ctx.countryCloseIcon }, null, 8, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createTextVNode(_toDisplayString(_ctx.countryNormalTopHeading) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.countryBoldTopHeading), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesJson, (country) => {
              return (_openBlock(), _createElementBlock("div", {
                key: country.CountryName.Value,
                class: "header__country-list-item"
              }, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(country.CountryName.Value), 1),
                _createElementVNode("a", {
                  class: "header__country-link",
                  href: country.Link.Url
                }, _toDisplayString(country.RedirectionText.Value), 9, _hoisted_31),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(country.CountriesVariants
                  .CountryItems, (variant, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("a", {
                      if: "variant.Link",
                      class: "header__country-link",
                      href: variant.Link.Url
                    }, _toDisplayString(variant.RedirectionText.Value), 9, _hoisted_32)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "header__dropdown-overlay",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedIndex = -1))
      })
    ], 34),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.selectedIndex === 1 ? 'active' : '', "header__dropdown"])
    }, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", {
          class: "header__dropdown-close",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedIndex = -1))
        }, [
          _createTextVNode(_toDisplayString(_ctx.searchCloseLabel) + " ", 1),
          _createElementVNode("img", { src: _ctx.searchCloseIcon }, null, 8, _hoisted_34)
        ]),
        _hoisted_35
      ]),
      _createElementVNode("div", {
        class: "header__dropdown-overlay",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedIndex = -1))
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.selectedIndex === 2 ? 'active' : '', "header__dropdown"])
    }, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", {
          class: "header__dropdown-close",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedIndex = -1))
        }, [
          _createTextVNode(_toDisplayString(_ctx.searchCloseLabel) + " ", 1),
          _createElementVNode("img", { src: _ctx.searchCloseIcon }, null, 8, _hoisted_37)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.searchBoldTopHeading), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.searchNormalTopHeading), 1)
          ]),
          _createElementVNode("form", {
            action: _ctx.searchButtonLink,
            method: "GET",
            class: "header__search-form"
          }, [
            _createElementVNode("input", {
              placeholder: _ctx.searchPlaceholder,
              type: "text",
              name: "keyword",
              minlength: "3",
              required: ""
            }, null, 8, _hoisted_41),
            _createElementVNode("button", _hoisted_42, [
              _createElementVNode("img", { src: _ctx.searchButtonIcon }, null, 8, _hoisted_43),
              _createTextVNode(" " + _toDisplayString(_ctx.searchButtonLabel), 1)
            ])
          ], 8, _hoisted_40)
        ])
      ]),
      _createElementVNode("div", {
        class: "header__dropdown-overlay",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedIndex = -1))
      })
    ], 2),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}